import { Reveal, Overline } from "@/components/Reveal";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQ } from "@/data/content";

export default function FaqSection() {
  return (
    <section id="faq" className="bg-white py-24 lg:py-32" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <Reveal>
          <Overline>Questions fréquentes</Overline>
          <h2 className="font-display text-3xl lg:text-4xl font-bold tracking-tight text-midnight">
            Tout comprendre sur le CPE, le Décret Tertiaire et les CEE
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-12 border-t border-slate-200">
            {FAQ.map((item, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-b border-slate-200" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left font-display font-bold text-midnight text-lg hover:no-underline py-6 hover:text-emerald">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 font-light leading-relaxed text-base pb-6">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
